import { Module } from 'vuex';
import { NodeLoginHistoryExcludeConditionState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeLoginHistoryExcludeConditionState = {
    nodeLoginHistoryExcludeConditions: undefined,
    nodeLoginHistoryExcludeConditionCount: 0,
    nodeLoginHistoryExcludeConditionDetails: {
        node_login_history_exclude_condition: undefined,
        nodes: undefined,
    },
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const nodeLoginHistoryExcludeCondition: Module<NodeLoginHistoryExcludeConditionState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
